import gql from 'graphql-tag';

export const PublicLinkInformationQuery = gql`
	query PublicLinkInformationQuery($publicLinkId: ID!) {
		publicLinkInformation(id: $publicLinkId) {
			id
			referenceId
			title
			type
			history {
				createdDate
				lastUpdated
			}
			properties(key: "editor") {
				nodes {
					id
					key
					value
				}
			}
			space {
				alias
				id
				key
				name
				iconPath
			}
		}
	}
`;
